import * as ACTIONS from "./actionTypes";
import { getPersistData } from "../../utils/utils";

const persistData = getPersistData();

export interface TransactionData {
    fileUrl: string;
    message: string;
    warrantyId: number;
    warrantyNumber?: any;
    proceedToPayment?: boolean;
    canGenerateReport?: boolean;
}

interface InitialState {
    isTransactionFailed: boolean;
    redirectUrl: string;
    isDownloading: boolean;
    isTransactionInitiating: boolean;
    transactionData: TransactionData;
    isAlreadyPaymentInitiated: boolean;
}

export const initialState: InitialState = {
    transactionData: null,
    isTransactionInitiating: false,
    redirectUrl: null,
    isDownloading: false,
    isTransactionFailed: false,
    isAlreadyPaymentInitiated: persistData && persistData.isAlreadyPaymentInitiated,
};

const reducer = (state = initialState, { type, payload }): InitialState => {
    switch (type) {
        case ACTIONS.UPDATE_NAVIGATION: {
            return { ...state, redirectUrl: payload.redirectUrl, transactionData: payload };
        }
        case ACTIONS.UPDATE_INIT_TRANSACTION: {
            return { ...state, isTransactionInitiating: true };
        }
        case ACTIONS.UPDATE_INIT_TRANSACTION_COMPLETED: {
            return { ...state, isTransactionInitiating: false };
        }
        case ACTIONS.UPDATE_TRANSACTION_DATA: {
            return { ...state, transactionData: payload };
        }
        case ACTIONS.CLEAR_TRANSACTION_DATA: {
            return { ...state, transactionData: null };
        }
        case ACTIONS.TRANSACTION_FAILED: {
            return { ...state, isTransactionFailed: true };
        }
        case ACTIONS.UPDATE_ALREADY_PAYMENT_INITIATED: {
            return { ...state, isAlreadyPaymentInitiated: false };
        }
        case ACTIONS.GENERATE_FULL_WARRANTY: 
        case ACTIONS.GENERATE_SUMMARY_WARRANTY: {
            return { ...state, isDownloading: true };
        }
        case ACTIONS.GENERATE_FULL_WARRANTY_DOWNLOADED:
        case ACTIONS.GENERATE_SUMMARY_WARRANTY_DOWNLOADED: {
            return { ...state, isDownloading: false };
        }
        case ACTIONS.DOWNLOAD_SUMMARY_PDF:
            return {...state, isDownloading: true};
        case ACTIONS.DOWNLOAD_SUMMARY_PDF_SUCCESS:
            return {...state, isDownloading: false};
        case ACTIONS.DOWNLOAD_SUMMARY_PDF_FAILURE:
            return {...state, isDownloading: false};
        default: {
            return state;
        }
    }
};

export default reducer;
